import { oneLine, stripIndent } from "common-tags"

/*
Forked and modified from gatsby-plugin-google-tagmanager: https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-plugin-google-tagmanager/src/gatsby-ssr.js
*/


// removed +'${environmentParamStr}'
const generateGTMScript = ({ tagContainerId, dataLayerName, selfHostedOrigin }) =>
  stripIndent`
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    '${selfHostedOrigin}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','${dataLayerName}', '${tagContainerId}');`


// <noscript> should be placed in the <body>, since <noscript> initiates an iFrame and iFrame is not supported in the <head>
const generateGTMIframe = ({ tagContainerId, selfHostedOrigin }) =>
  oneLine`<iframe src="${selfHostedOrigin}/ns.html?id=${tagContainerId}" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe>`


const setupGTMServerside = ( tagContainerId ) => {

  // define config constants. gtmAuth, gtmPreview, and enableWebVitalsTracking from the original plugin are not needed, so have been removed
  const dataLayerName = 'dataLayer'
  const defaultDataLayer = { platform: 'gatsby' } // "Should be an object or a function."
  const selfHostedOrigin = 'https://www.googletagmanager.com'.replace(/\/$/, ``) // Remove trailing slash, if not standard 'googletagmanager.com'
  const includeInDevelopment = true

  if (!process.env.NODE_ENV === 'production' && !includeInDevelopment) {
    return
  }

  // an example of defaultDataLayerCode: `window.dataLayer = window.dataLayer || []; window.dataLayer.push({"platform":"gatsby"}); `
  let defaultDataLayerCode = `window.${dataLayerName} = window.${dataLayerName} || []; `
  defaultDataLayerCode += stripIndent`window.${dataLayerName}.push(${JSON.stringify(defaultDataLayer)});`

  const headGTMScript = oneLine`
    ${defaultDataLayerCode}
    ${generateGTMScript({
      tagContainerId,
      dataLayerName,
      selfHostedOrigin
    })}`

  const bodyGTMIframe = generateGTMIframe({ tagContainerId, selfHostedOrigin });

  return { headGTMScript, bodyGTMIframe }
}

export default setupGTMServerside;
